import validator from "validator";


const addEditPermissionValidation = (data) => {
  let errors = {};
  if (validator.isEmpty(data?.userName?.trim()))
    errors.userName = "Please enter user name";

  if (validator.isEmpty(data?.email.trim()))
    errors.email = "Please enter email address";


  if (!validator.isEmpty(data?.email) && !validator.isEmail(data.email))
    errors.email = "Email address must be valid";


  if (data?.email && !validator.isEmail(data.email))
    errors.email = "Email address must be valid";

  if (validator.isEmpty(data?.password.trim()))
    errors.password = "Please enter password";

  return { errors, isValid: Object.keys(errors).length <= 0 };
};

export default addEditPermissionValidation



